import * as React from "react";
import * as _ from "lodash";
import ProductSegmentsTable from "../../components/products/ProductSegmentTable";
import { navigate } from "~/router";
import { useProductCategories } from "~/apps/pos/apis/productCategories";
import { useProductCategoryDeleteConfirm } from "../../components/products/useProductCategoryDeleteConfirm";

const ProductCategoryList = () => {
  const { page, pageSize, data, isLoading, handlePageChange } = useProductCategories();
  const { deleteConfirm, showDeleteConfirm } = useProductCategoryDeleteConfirm();

  const handleEdit = (category) => {
    navigate("pos.admin.products.categories.edit", { categoryId: category.id });
  };

  return (
    <>
      <ProductSegmentsTable
        loading={isLoading}
        page={page}
        pageSize={pageSize}
        data={data || []}
        onPageChange={handlePageChange}
        onEdit={handleEdit}
        onDelete={showDeleteConfirm}
      />
      {deleteConfirm}
    </>
  );
};

export default ProductCategoryList;
